<template>
  <!-- 案件詳細 -->
  <div id="CpapEscrowRequestDetailEdit">
    <div id="item-contens">
      <!-- 器械の見積 -->
      <div v-if="orderDevice" class="card-content margin-top">
        <span style="font-size: 20px">器械</span>
        <table>
          <template v-for="(item, index) in data.escrowDeviceList">
            <tr :key="index">
              <table
                style="
                  margin: 15px auto;
                  border-bottom: 1px solid;
                  border-bottom-color: silver;
                "
              >
                <tr>
                  <th style="width: 90px">品目</th>
                  <td style="width: 300px; vertical-align: middle" colspan="3">
                    <select
                      name="item"
                      @change="changeEscrowItem($event, index, 'device')"
                      v-model="data.escrowDeviceList[index].itemName"
                    >
                      <option
                        v-for="(i, index) in escrowDeviceSelectList"
                        :key="index"
                        :value="i.value"
                      >
                        {{ i.text }}
                      </option>
                    </select>
                  </td>
                  <td style="width: 130px" class="tdBold">品目コード</td>
                  <td style="vertical-align: middle; width: 150px">
                    <span v-if="data.escrowDeviceList[index].itemName">{{
                      data.escrowDeviceList[index].itemCode
                    }}</span>
                  </td>
                  <td style="width: 80px" class="tdBold">個数</td>
                  <td style="vertical-align: middle; width: 100px">
                    <select
                      name="item"
                      v-model="data.escrowDeviceList[index].quantity"
                    >
                      <option
                        v-for="(i, index) in quantitySelectList"
                        :key="index"
                        :value="i.quantity"
                      >
                        {{ i.text }}
                      </option>
                    </select>
                  </td>
                  <td colspan="2">
                    <b-button
                      class="is-primary"
                      style="width: 50px; margin-left: 50px"
                      v-on:click="delItems(index)"
                      >削除</b-button
                    >
                  </td>
                </tr>
                <tr style="height: 45px">
                  <th style="width: 90px">見積番号</th>
                  <td style="width: 270px; vertical-align: middle">
                    <b-button
                      style="width: 100px; height: 22px"
                      :disabled="!data.escrowDeviceList[index].itemName"
                      v-on:click="
                        quotationModalOn(
                          data.escrowDeviceList[index].itemCode,
                          data.escrowDeviceList[index].itemName,
                          index,
                          'item'
                        )
                      "
                      >見積選択</b-button
                    >
                    <b-button
                      v-if="data.escrowDeviceList[index].quotationNumber"
                      class="clearBtn"
                      icon-left="eraser"
                      @click="
                        deleteQuotation(
                          data.escrowDeviceList[index].itemCode,
                          data.escrowDeviceList[index].itemName,
                          index,
                          'item'
                        )
                      "
                    ></b-button>
                    <span
                      v-else
                      style="display: inline-block; width: 35px"
                    ></span>
                    <span v-if="data.escrowDeviceList[index].quotationNumber">{{
                      data.escrowDeviceList[index].quotationNumber
                    }}</span>
                    <span v-else style="color: red; vertical-align: middle"
                      >見積未選択</span
                    >
                  </td>
                  <td></td>
                  <td style="width: 110px" class="tdBold">見積詳細番号</td>
                  <td style="width: 250px; vertical-align: middle" colspan="2">
                    <span
                      v-if="data.escrowDeviceList[index].quotationDetailsNumber"
                      >{{
                        data.escrowDeviceList[index].quotationDetailsNumber
                      }}</span
                    >
                    <span v-else style="color: red">見積未選択</span>
                  </td>
                  <td style="width: 80px" class="tdBold">納入価</td>
                  <td style="width: 100px; vertical-align: middle">
                    <span v-if="data.escrowDeviceList[index].deliveryPrice">{{
                      data.escrowDeviceList[index].deliveryPrice
                    }}</span>
                  </td>
                  <td style="width: 60px" class="tdBold">見積日</td>
                  <td style="width: 130px; vertical-align: middle">
                    <span
                      v-if="
                        data.escrowDeviceList[index].latestOrderRegisteredDate
                      "
                      >{{
                        data.escrowDeviceList[index].latestOrderRegisteredDate
                      }}</span
                    >
                  </td>
                </tr>
              </table>
            </tr>
          </template>
        </table>
      </div>
      <b-button
        class="is-primary"
        style="margin-top: 10px"
        v-on:click="addItems()"
        >器械追加</b-button
      >
      <!-- マスクの見積 -->
      <div v-if="orderMask" class="card-content margin-top">
        <span style="font-size: 20px">マスク</span>
        <table>
          <template v-for="(item, index) in data.escrowMaskList">
            <tr :key="index">
              <table
                style="
                  margin: 15px auto;
                  border-bottom: 1px solid;
                  border-bottom-color: silver;
                "
              >
                <tr>
                  <th style="width: 90px">品目</th>
                  <td style="width: 300px; vertical-align: middle" colspan="3">
                    <select
                      name="item"
                      @change="changeEscrowItem($event, index, 'mask')"
                      v-model="data.escrowMaskList[index].itemName"
                    >
                      <option
                        v-for="(i, index) in escrowMaskSelectList"
                        :key="index"
                        :value="i.value"
                      >
                        {{ i.text }}
                      </option>
                    </select>
                  </td>
                  <td style="width: 130px" class="tdBold">品目コード</td>
                  <!-- マスクの場合のみ、選択した品目により品目コード選択のプルダウンの内容を変更する -->
                  <td style="vertical-align: middle; width: 150px">
                    <select
                      v-if="
                        data.escrowMaskList[index].itemName == 'ﾋﾟｺﾈｰｻﾞﾙﾏｽｸ'
                      "
                      name="item"
                      v-model="data.escrowMaskList[index].itemCode"
                    >
                      <option
                        v-for="(i, index) in picoNesalMaskList"
                        :key="index"
                        :value="i.value"
                      >
                        {{ i.text }}
                      </option>
                    </select>
                    <select
                      v-else-if="
                        data.escrowMaskList[index].itemName == 'ｳｨｽﾌﾟﾈｰｻﾞﾙﾏｽｸ'
                      "
                      name="item"
                      v-model="data.escrowMaskList[index].itemCode"
                    >
                      <option
                        v-for="(i, index) in wispNesalMaskList"
                        :key="index"
                        :value="i.value"
                      >
                        {{ i.text }}
                      </option>
                    </select>
                  </td>
                  <td style="width: 80px" class="tdBold">個数</td>
                  <td style="vertical-align: middle; width: 100px">
                    <select
                      name="item"
                      v-model="data.escrowMaskList[index].quantity"
                    >
                      <option
                        v-for="(i, index) in quantitySelectList"
                        :key="index"
                        :value="i.quantity"
                      >
                        {{ i.text }}
                      </option>
                    </select>
                  </td>
                  <td colspan="2">
                    <b-button
                      class="is-primary"
                      style="width: 50px; margin-left: 50px"
                      v-on:click="delMasks(index)"
                      >削除</b-button
                    >
                  </td>
                </tr>
                <tr style="height: 45px">
                  <th style="width: 90px">見積番号</th>
                  <td style="width: 270px; vertical-align: middle">
                    <b-button
                      style="width: 100px; height: 22px"
                      :disabled="!data.escrowMaskList[index].itemName"
                      v-on:click="
                        quotationModalOn(
                          data.escrowMaskList[index].itemCode,
                          data.escrowMaskList[index].itemName,
                          index,
                          'item'
                        )
                      "
                      >見積選択</b-button
                    >
                    <b-button
                      v-if="data.escrowMaskList[index].quotationNumber"
                      class="clearBtn"
                      icon-left="eraser"
                      @click="
                        deleteQuotation(
                          data.escrowMaskList[index].itemCode,
                          data.escrowMaskList[index].itemName,
                          index,
                          'item'
                        )
                      "
                    ></b-button>
                    <span
                      v-else
                      style="display: inline-block; width: 35px"
                    ></span>
                    <span v-if="data.escrowMaskList[index].quotationNumber">{{
                      data.escrowMaskList[index].quotationNumber
                    }}</span>
                    <span v-else style="color: red; vertical-align: middle"
                      >見積未選択</span
                    >
                  </td>
                  <td></td>
                  <td style="width: 110px" class="tdBold">見積詳細番号</td>
                  <td style="width: 250px; vertical-align: middle" colspan="2">
                    <span
                      v-if="data.escrowMaskList[index].quotationDetailsNumber"
                      >{{
                        data.escrowMaskList[index].quotationDetailsNumber
                      }}</span
                    >
                    <span v-else style="color: red">見積未選択</span>
                  </td>
                  <td style="width: 80px" class="tdBold">納入価</td>
                  <td style="width: 100px; vertical-align: middle">
                    <span v-if="data.escrowMaskList[index].deliveryPrice">{{
                      data.escrowMaskList[index].deliveryPrice
                    }}</span>
                  </td>
                  <td style="width: 60px" class="tdBold">見積日</td>
                  <td style="width: 130px; vertical-align: middle">
                    <span
                      v-if="
                        data.escrowMaskList[index].latestOrderRegisteredDate
                      "
                      >{{
                        data.escrowMaskList[index].latestOrderRegisteredDate
                      }}</span
                    >
                  </td>
                </tr>
              </table>
            </tr>
          </template>
        </table>
      </div>
      <b-button
        class="is-primary"
        style="margin-top: 10px"
        v-on:click="addMasks()"
        >マスク追加</b-button
      >
      <!-- 用品の見積 -->
      <div v-if="orderOption" class="card-content margin-top">
        <span style="font-size: 20px">用品</span>
        <table>
          <template v-for="(item, index) in data.escrowOptionItemList">
            <tr :key="index">
              <table
                style="
                  margin: 15px auto;
                  border-bottom: 1px solid;
                  border-bottom-color: silver;
                "
              >
                <tr>
                  <th style="width: 90px">品目</th>
                  <td style="width: 300px; vertical-align: middle" colspan="3">
                    <select
                      name="item"
                      @change="changeEscrowItem($event, index, 'option')"
                      v-model="data.escrowOptionItemList[index].itemName"
                    >
                      <option
                        v-for="(i, index) in escrowOptionItemSelectList"
                        :key="index"
                        :value="i.value"
                      >
                        {{ i.text }}
                      </option>
                    </select>
                  </td>
                  <td style="width: 130px" class="tdBold">品目コード</td>
                  <td style="vertical-align: middle; width: 150px">
                    <span v-if="data.escrowOptionItemList[index].itemName">{{
                      data.escrowOptionItemList[index].itemCode
                    }}</span>
                  </td>
                  <td style="width: 80px" class="tdBold">個数</td>
                  <td style="vertical-align: middle; width: 100px">
                    <select
                      name="item"
                      v-model="data.escrowOptionItemList[index].quantity"
                    >
                      <option
                        v-for="(i, index) in quantitySelectList"
                        :key="index"
                        :value="i.quantity"
                      >
                        {{ i.text }}
                      </option>
                    </select>
                  </td>
                  <td colspan="2">
                    <b-button
                      class="is-primary"
                      style="width: 50px; margin-left: 50px"
                      v-on:click="delOptions(index)"
                      >削除</b-button
                    >
                  </td>
                </tr>
                <tr style="height: 45px">
                  <th style="width: 90px">見積番号</th>
                  <td style="width: 270px; vertical-align: middle">
                    <b-button
                      style="width: 100px; height: 22px"
                      :disabled="!data.escrowOptionItemList[index].itemName"
                      v-on:click="
                        quotationModalOn(
                          data.escrowOptionItemList[index].itemCode,
                          data.escrowOptionItemList[index].itemName,
                          index,
                          'item'
                        )
                      "
                      >見積選択</b-button
                    >
                    <b-button
                      v-if="data.escrowOptionItemList[index].quotationNumber"
                      class="clearBtn"
                      icon-left="eraser"
                      @click="
                        deleteQuotation(
                          data.escrowOptionItemList[index].itemCode,
                          data.escrowOptionItemList[index].itemName,
                          index,
                          'item'
                        )
                      "
                    ></b-button>
                    <span
                      v-else
                      style="display: inline-block; width: 35px"
                    ></span>
                    <span
                      v-if="data.escrowOptionItemList[index].quotationNumber"
                      >{{
                        data.escrowOptionItemList[index].quotationNumber
                      }}</span
                    >
                    <span v-else style="color: red; vertical-align: middle"
                      >見積未選択</span
                    >
                  </td>
                  <td></td>
                  <td style="width: 110px" class="tdBold">見積詳細番号</td>
                  <td style="width: 250px; vertical-align: middle" colspan="2">
                    <span
                      v-if="
                        data.escrowOptionItemList[index].quotationDetailsNumber
                      "
                      >{{
                        data.escrowOptionItemList[index].quotationDetailsNumber
                      }}</span
                    >
                    <span v-else style="color: red">見積未選択</span>
                  </td>
                  <td style="width: 80px" class="tdBold">納入価</td>
                  <td style="width: 100px; vertical-align: middle">
                    <span
                      v-if="data.escrowOptionItemList[index].deliveryPrice"
                      >{{
                        data.escrowOptionItemList[index].deliveryPrice
                      }}</span
                    >
                  </td>
                  <td style="width: 60px" class="tdBold">見積日</td>
                  <td style="width: 130px; vertical-align: middle">
                    <span
                      v-if="
                        data.escrowOptionItemList[index]
                          .latestOrderRegisteredDate
                      "
                      >{{
                        data.escrowOptionItemList[index]
                          .latestOrderRegisteredDate
                      }}</span
                    >
                  </td>
                </tr>
              </table>
            </tr>
          </template>
        </table>
      </div>
      <b-button
        class="is-primary"
        style="margin-top: 10px"
        v-on:click="addOptions()"
        >用品追加</b-button
      >
      <!-- 同梱品 -->
      <div v-if="orderBundle" class="card-content margin-top">
        <span style="font-size: 20px">同梱品</span>
        <table>
          <template v-for="(item, index) in data.escrowBundleItemList">
            <tr :key="index">
              <table
                style="
                  margin: 15px auto;
                  border-bottom: 1px solid;
                  border-bottom-color: silver;
                "
              >
                <tr>
                  <th style="width: 90px">品目</th>
                  <td style="width: 300px; vertical-align: middle" colspan="3">
                    <select
                      name="item"
                      @change="changeEscrowItem($event, index, 'bundle')"
                      v-model="data.escrowBundleItemList[index].itemName"
                    >
                      <option
                        v-for="(i, index) in escrowBundleItemSelectList"
                        :key="index"
                        :value="i.value"
                      >
                        {{ i.text }}
                      </option>
                    </select>
                  </td>
                  <td style="width: 130px" class="tdBold">品目コード</td>
                  <td style="vertical-align: middle; width: 150px">
                    <span v-if="data.escrowBundleItemList[index].itemName">{{
                      data.escrowBundleItemList[index].itemCode
                    }}</span>
                  </td>
                  <td style="width: 80px" class="tdBold">個数</td>
                  <td style="vertical-align: middle; width: 100px">
                    <select
                      name="item"
                      v-model="data.escrowBundleItemList[index].quantity"
                    >
                      <option
                        v-for="(i, index) in quantitySelectList"
                        :key="index"
                        :value="i.quantity"
                      >
                        {{ i.text }}
                      </option>
                    </select>
                  </td>
                  <td colspan="2">
                    <b-button
                      class="is-primary"
                      style="width: 50px; margin-left: 50px"
                      v-on:click="delBundles(index)"
                      >削除</b-button
                    >
                  </td>
                </tr>
              </table>
            </tr>
          </template>
        </table>
      </div>
      <b-button
        class="is-primary"
        style="margin-top: 10px"
        v-on:click="addBundles()"
        >同梱品追加</b-button
      >
      <div class="card-content margin-top">
        <span style="font-size: 20px">配送情報</span>
        <table>
          <tr>
            <th>対象医療機関<span class="require" /></th>
            <td>
              <input
                type="text"
                v-model="data.targetHospitalName"
                maxlength="256"
                class="1"
                :name="'対象医療機関'"
                validate="required"
              />
            </td>
          </tr>
          <tr>
            <!-- <th>納品先<span class="require" /></th> -->
            <th>納品先<span /></th>
            <td>
              <div>
                <!-- 2024年に院内在庫の川越発送も可能にしたい（PH佐藤さん）2023.10.03 -->
                <b-radio
                  class="td_radio"
                  name="target"
                  v-model="data.delivaryTarget"
                  native-value="branch"
                  disabled
                  >支店</b-radio
                >
                <b-radio
                  class="td_radio"
                  name="target"
                  v-model="data.delivaryTarget"
                  native-value="hospital"
                  >医療機関</b-radio
                >
                <!-- <span>医療機関</span> -->
              </div>
            </td>
          </tr>
          <tr>
            <th>注文者部署名</th>
            <td>
              <input type="text" v-model="data.divisionName" maxlength="100" />
            </td>
          </tr>
          <tr>
            <th>注文者名<span class="require" /></th>
            <td>
              <input
                type="text"
                v-model="data.ordererName"
                maxlength="50"
                class="1"
                :name="'注文者名'"
                validate="required"
              />
            </td>
          </tr>
          <tr v-if="data.delivaryTarget == 'branch'">
            <th>機器納品先支店<span class="require" /></th>
            <td>
              <select
                v-model="data.deliveryTargetBranchOffice"
                id="branchOfficeCode"
                validate="required"
              >
                <option
                  v-for="brunch in brunchList"
                  :key="brunch.branchOfficeCode"
                  :value="brunch.branchOfficeCode"
                >
                  {{ brunch.branchOfficeName }}
                </option>
              </select>
            </td>
          </tr>
          <tr>
            <th>郵便番号<span class="require" /></th>
            <td>
              <input
                v-model="data.deliveryPostCode"
                type="text"
                maxlength="7"
                style="width: 270px"
                class="1"
                :class="{ 'border-red': invalidPostcode }"
                name="郵便番号"
                validate="required|numeric"
                :placeholder="postcodePlaceholder"
              />
              <b-button
                style="margin-left: 10px; width: 150px; height: 27px"
                v-on:click="patientAddressSearch(data.deliveryPostCode)"
              >
                郵便番号検索
              </b-button>
              <div v-show="invalidPostcode" class="text-red">
                {{ invalidNumberMessage }}
              </div>
            </td>
          </tr>
          <tr>
            <th>住所<span class="require" /></th>
            <td>
              <input
                type="text"
                v-model="data.deliveryAddress1"
                maxlength="256"
                class="1"
                :name="'住所'"
                validate="required"
              />
            </td>
          </tr>
          <tr v-if="data.delivaryTarget == 'hospital'">
            <th>住所（丁目、番地）<span class="require" /></th>
            <td>
              <input
                type="text"
                v-model="data.deliveryAddress2"
                maxlength="256"
                class="1"
                :name="'住所（丁目、番地）'"
                validate="required"
              />
            </td>
          </tr>
          <tr v-if="data.delivaryTarget == 'hospital'">
            <th>住所（建物名、号室）</th>
            <td>
              <input
                type="text"
                v-model="data.deliveryAddress3"
                maxlength="256"
              />
            </td>
          </tr>
          <tr>
            <th>納品先宛名<span class="require" /></th>
            <td>
              <input
                type="text"
                v-model="data.receiverName"
                maxlength="100"
                class="1"
                :name="'納品先宛名'"
                validate="required"
              />
            </td>
          </tr>
          <tr>
            <th>連絡先（電話番号）</th>
            <td>
              <input
                type="text"
                v-model="data.deliveryPhoneNumber"
                maxlength="11"
                id="mobilePhone"
                class="1"
                :class="{ 'border-red': invalidMobilePhoneNumber }"
                name="連絡先（携帯電話）"
                validate="numeric"
                :placeholder="phonePlaceholder"
              />
              <div v-show="invalidMobilePhoneNumber" class="text-red">
                {{ invalidNumberMessage }}
              </div>
            </td>
          </tr>
        </table>
        <template v-if="innerUser">
          <tr>
            <th style="vertical-align: middle; width: 220px">
              納品書コメント1
            </th>
            <td>
              <textarea
                style="width: 900px"
                v-model="data.deliveryStatementComment1"
              ></textarea>
            </td>
          </tr>
          <tr>
            <th style="vertical-align: middle; width: 220px">
              納品書コメント2
            </th>
            <td>
              <textarea
                style="width: 900px"
                v-model="data.deliveryStatementComment2"
              ></textarea>
            </td>
          </tr>
          <tr
            v-if="
              data.delivaryTarget == 'hospital' ||
              !data.deliveryTargetBranchOffice
            "
          >
            <!-- 納品先が医療機関の場合 -->
            <th style="vertical-align: middle; width: 220px">
              発送元<span class="require" />
            </th>
            <td style="width: 900px">
              <div>
                <select
                  v-model="data.senderType"
                  class="2"
                  name="発送元"
                  validate="required"
                  @input="selectSender"
                  style="width: 70%; vertical-align: middle"
                  disabled
                >
                  <option value=""></option>
                  <option
                    v-for="ship in cpapSenderMaster"
                    :key="ship.code"
                    :value="ship.code"
                  >
                    {{ ship.name }}
                  </option>
                </select>
                <b-button
                  v-if="innerUser"
                  class="is-primary"
                  style="margin-left: 10px; height: 30px"
                  @click="cpapStockModalActive = true"
                  >在庫検索</b-button
                >
              </div>
            </td>
          </tr>
          <tr v-if="data.delivaryTarget == 'hospital'"></tr>
          <template v-if="data.senderType == 1">
            <tr>
              <th style="vertical-align: middle">
                発送方法<span class="require" />
              </th>
              <td>
                <select
                  v-model="data.shippingMethod"
                  class="2"
                  name="発送方法"
                  validate="required"
                >
                  <option value=""></option>
                  <option
                    v-for="ship in cpapShippingMethodList"
                    :key="ship.code"
                    :value="ship.code"
                  >
                    {{ ship.name }}
                  </option>
                </select>
              </td>
            </tr>
            <tr>
              <th style="vertical-align: middle; padding-top: 5px">
                持出元営業所
              </th>
              <td>
                {{ officeCode | codeToValueFilter(branchOfficeMaster) }}
              </td>
            </tr>
            <tr>
              <th style="vertical-align: middle">
                保管場所<span class="require" />
              </th>
              <td>
                <select
                  id="depositoryCode"
                  class="2"
                  name="保管場所"
                  validate="required"
                  v-model="data.depositoryCode"
                >
                  <option value=""></option>
                  <option
                    v-for="item in depositoryCodeMaster"
                    :key="item.depositoryCode"
                    :value="item.depositoryCode"
                  >
                    {{ item.depositoryName }}({{ item.depositoryCode }})
                  </option>
                </select>
                <span style="color: red"
                  >※他拠点を選択する場合は、事前に連絡して承諾を得てください。</span
                >
              </td>
            </tr>
            <tr>
              <th style="vertical-align: top">
                出荷日<span class="require" />
              </th>
              <td>
                <input
                  type="date"
                  class="2"
                  name="出荷日"
                  validate="required"
                  v-model="data.shippingDate"
                  :min="data.billingStartMin"
                />
              </td>
            </tr>
          </template>
        </template>
      </div>
      <div class="card-content margin-top">
        <span style="font-size: 20px">オーダー情報</span>
        <table>
          <template v-if="innerUser">
            <tr>
              <th style="vertical-align: top">
                請求開始日<span class="require" />
              </th>
              <td>
                <input
                  type="date"
                  class="2"
                  name="請求開始日"
                  validate="required"
                  v-model="data.billingStartDate"
                />
              </td>
            </tr>
            <tr>
              <th style="vertical-align: top">請求書コメント</th>
              <td><textarea v-model="data.billComment"></textarea></td>
            </tr>
            <tr>
              <th style="vertical-align: top">
                診療科コード<span class="require" />
              </th>
              <td>
                <select
                  id="departmentCode"
                  class="2"
                  name="診療科コード"
                  validate="required"
                  v-model="data.departmentCode"
                >
                  <option
                    v-for="department in this.departmentMaster"
                    :value="department.value"
                    :key="department.value"
                  >
                    {{ department.label }}（{{ department.value }}）
                  </option>
                </select>
              </td>
            </tr>
            <tr>
              <th style="vertical-align: top">
                得意先区分<span class="require" />
              </th>
              <td>
                <select
                  id="customerClass"
                  class="2"
                  name="得意先区分"
                  validate="required"
                  v-model="data.customerClass"
                >
                  <option
                    v-for="customer in this.customerCategory"
                    :value="customer.value"
                    :key="customer.value"
                  >
                    {{ customer.label }}
                  </option>
                </select>
              </td>
            </tr>
          </template>
          <tr>
            <th style="vertical-align: top">備考</th>
            <td>
              <textarea
                maxlength="256"
                style="resize: vertical; max-width: 100%; height: 120px"
                v-model="data.memo"
              ></textarea>
            </td>
          </tr>
        </table>
      </div>
    </div>
    <!-- 品目単位の見積選択 -->
    <b-modal :active.sync="itemQuotationModalActive" has-modal-card full-screen>
      <QuotationSelectModal
        :hospital="data.medicalInstitutionCode"
        :selectItemModel="quotationItemName"
        title="品目見積選択"
        labelForOrg="品目名称"
        :topMsg="'対象品目コード：' + quotationItemCode"
        @select="setQuotationItem($event, quotationItemIndex)"
        :showDetailTargetData="data"
      ></QuotationSelectModal>
    </b-modal>
    <!-- 在庫検索 -->
    <b-modal :active.sync="cpapStockModalActive" has-modal-card full-screen>
      <CpapStockModal :targetOffice="'J' + officeCode"></CpapStockModal>
    </b-modal>
  </div>
</template>
<script>
import {
  invalidNumberMessage,
  postcodePlaceholder,
  phonePlaceholder,
  roll,
  cpapSenderMaster,
  cpapShippingMethodList,
  cpapRequestStatus,
  escrowContent,
  escrowDeviceSelectList,
  escrowMaskSelectList,
  escrowOptionItemSelectList,
  escrowBundleItemSelectList,
  quantitySelectList,
  picoNesalMaskList,
  wispNesalMaskList,
  escrowItemCodeList,
} from "@/components/mock/base/const.js";
import QuotationSelectModal from "@/components/mock/philips/common/QuotationSelectModal";
import CpapStockModal from "@/components/mock/philips/common/CpapStockModal";

export default {
  name: "CpapEscrowRequestDetailEdit",
  props: {
    data: null,
    showRequestInfo: { default: false },
    showRequestMemo: { default: true },
    innerUser: {},
    progress: "",
    kind: "",
    isEdit: null,
    isMasterAcquisition: true,
    cancelEdit: { default: false },
    deliveryHidden: { default: false },
    requestFlg: { default: false },
    directionsItem: { default: () => [] },
    viewerFlg: { default: false },
    commentFlg: { default: false },
  },
  methods: {
    patientAddressSearch: function (val) {
      // 検索対象の郵便番号を設定
      this.searchTargetPostCode = val;
      this.searchTargetAddress = null;
      this.postCodeSearch();
    },
    postCodeSearch: function () {
      var excuteApi = this.getAddressFromPostCodePOST;
      var successCallBack = this.getAddressFromPostCodePOSTSuccess;
      var errorCallBack = this.getAddressFromPostCodePOSTError;
      // WebAPI Call
      return this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    getAddressFromPostCodePOST: function (client) {
      return client.apis.apiCommon.getAddressFromPostCodePOST({
        body: {
          postCode: this.searchTargetPostCode,
        },
      });
    },
    getAddressFromPostCodePOSTSuccess: function (result) {
      this.searchTargetAddress = result.obj;
      this.searchTargetPostCode = "";
    },
    getAddressFromPostCodePOSTError: function (result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
      this.searchTargetPostCode = "";
    },
    getDepositoryCodeMaster: function () {
      this.depositoryCodeMaster = [];
      if (!this.officeCode) return;
      // Web Api Call
      var _this = this;
      this.apiCall(
        function (client) {
          return client.apis.apiCommon.getCpapStorageLocationPOST({
            body: {
              salesOfficeCode: "J" + _this.officeCode,
            },
          });
        },
        async function (result) {
          _this.depositoryCodeMaster = result.obj;
          if (!_this.data.depositoryCode) {
            var targetOffice = _this.depositoryCodeMaster.find(
              (val) => val.depositoryCode == "J" + _this.officeCode
            );
            if (targetOffice) {
              _this.data.depositoryCode = targetOffice.depositoryCode;
            }
          }
        },
        function (result) {
          _this.showErrorMessage(result);
          _this.webHtApiErr = true;
        }
      );
    },
    deleteQuotation: function (code, name, index, kinds) {
      switch (kinds) {
        case "item":
          this.data.escrowDeviceList[index].quotationNumber = "";
          this.data.escrowDeviceList[index].quotationDetailsNumber = "";
          this.data.escrowDeviceList[index].deliveryPrice = "";
          this.data.escrowDeviceList[index].latestOrderRegisteredDate = "";
          break;
        case "mask":
          this.data.escrowMaskList[index].quotationNumber = "";
          this.data.escrowMaskList[index].quotationDetailsNumber = "";
          this.data.escrowMaskList[index].deliveryPrice = "";
          this.data.escrowMaskList[index].latestOrderRegisteredDate = "";
          break;
        case "option":
          this.data.escrowOptionItemList[index].quotationNumber = "";
          this.data.escrowOptionItemList[index].quotationDetailsNumber = "";
          this.data.escrowOptionItemList[index].deliveryPrice = "";
          this.data.escrowOptionItemList[index].latestOrderRegisteredDate = "";
          break;
      }
    },
    quotationModalOn: function (code, name, index, kinds) {
      this.quotationItemCode = code;
      this.quotationItemName = name;
      this.quotationItemIndex = index;
      this.quotationItemKind = kinds;
      this.itemQuotationModalActive = true;
    },
    setQuotationItem: function (quotationInfo, index) {
      this.data.billingDestinationCode = quotationInfo.billingDestinationCode;
      switch (this.quotationItemKind) {
        case "item":
          this.data.escrowDeviceList[index].quotationNumber =
            quotationInfo.quotationNumber;
          this.data.escrowDeviceList[index].quotationDetailsNumber =
            quotationInfo.items[0].quotationDetailsNumber;
          this.data.escrowDeviceList[index].deliveryPrice =
            quotationInfo.items[0].deliveryPrice;
          this.data.escrowDeviceList[index].latestOrderRegisteredDate =
            quotationInfo.items[0].latestOrderRegisteredDate;
          break;
        case "mask":
          this.data.escrowMaskList[index].quotationNumber =
            quotationInfo.quotationNumber;
          this.data.escrowMaskList[index].quotationDetailsNumber =
            quotationInfo.items[0].quotationDetailsNumber;
          this.data.escrowMaskList[index].deliveryPrice =
            quotationInfo.items[0].deliveryPrice;
          this.data.escrowMaskList[index].latestOrderRegisteredDate =
            quotationInfo.items[0].latestOrderRegisteredDate;
          break;
        case "option":
          this.data.escrowOptionItemList[index].quotationNumber =
            quotationInfo.quotationNumber;
          this.data.escrowOptionItemList[index].quotationDetailsNumber =
            quotationInfo.items[0].quotationDetailsNumber;
          this.data.escrowOptionItemList[index].deliveryPrice =
            quotationInfo.items[0].deliveryPrice;
          this.data.escrowOptionItemList[index].latestOrderRegisteredDate =
            quotationInfo.items[0].latestOrderRegisteredDate;
          break;
      }
      console.log("quotationInfo : " + JSON.stringify(quotationInfo));
      this.quotationItemCode = "";
      this.quotationItemName = "";
      this.quotationItemIndex = "";
      this.quotationItemKind = "";
    },
    selectSender: function () {
      if (!this.data.senderType) return false;
      var target = this.cpapSenderMaster.find(
        (val) => val.code == this.data.senderType
      );
      if (!target || target.name.indexOf("川越") != -1) {
        this.data.shippingMethod = "1";
      }
    },
    isSendBranch: function () {
      if (!this.data.senderType) return false;
      var target = this.cpapSenderMaster.find(
        (val) => val.code == this.data.senderType
      );
      if (target && target.name.indexOf("支店") != -1) {
        // 支店発送の場合
        return true;
      }
      return false;
    },
    getBrunchAddressList: function () {
      try {
        this.$store
          .dispatch("getBrunchAddressList", {})
          .then((result) => {
            this.brunchList = result.obj;
          })
          .catch((error) => {
            console.log(error);
            this.showErrorMessage("予期しないエラーが発生しました。");
          });
      } catch (err) {
        console.log(error);
        this.showErrorMessage("予期しないエラーが発生しました。");
      }
    },
    addItems: function () {
      this.data.escrowDeviceList.push({ ...escrowContent });
      if (!this.orderDevice) {
        this.orderDevice = true;
      }
    },
    addMasks: function () {
      this.data.escrowMaskList.push({ ...escrowContent });
      if (!this.orderMask) {
        this.orderMask = true;
      }
    },
    addOptions: function () {
      this.data.escrowOptionItemList.push({ ...escrowContent });
      if (!this.orderOption) {
        this.orderOption = true;
      }
    },
    addBundles: function () {
      this.data.escrowBundleItemList.push({ ...escrowContent });
      if (!this.orderBundle) {
        this.orderBundle = true;
      }
    },
    delItems: function (index) {
      this.data.escrowDeviceList.splice(index, 1);
      if (this.data.escrowDeviceList.length < 1) {
        this.orderDevice = false;
      }
    },
    delMasks: function (index) {
      this.data.escrowMaskList.splice(index, 1);
      if (this.data.escrowMaskList.length < 1) {
        this.orderMask = false;
      }
    },
    delOptions: function (index) {
      this.data.escrowOptionItemList.splice(index, 1);
      if (this.data.escrowOptionItemList.length < 1) {
        this.orderOption = false;
      }
    },
    delBundles: function (index) {
      this.data.escrowBundleItemList.splice(index, 1);
      if (this.data.escrowBundleItemList.length < 1) {
        this.orderBundle = false;
      }
    },
    changeEscrowItem: function (selectItem, index, category) {
      const target = this.escrowItemCodeList.find(
        ({ itemName }) => itemName == selectItem.target.value
      );
      console.log("target : " + JSON.stringify(target));
      switch (category) {
        case "device":
          this.data.escrowDeviceList[index].itemCode = target.itemCode;
          break;
        case "option":
          this.data.escrowOptionItemList[index].itemCode = target.itemCode;
          break;
        case "bundle":
          this.data.escrowBundleItemList[index].itemCode = target.itemCode;
          break;
      }
    },
    getCpapChoicesList: async function() {
      this.departmentMaster = this.getCpapChoiceList(cpapChoicesType.departmentCode,false);
      this.customerCategory = this.getCpapChoiceList(cpapChoicesType.customerCategory,false);
    },
  },
  data() {
    const cpapCodeMaster = this.getCpapCodeMaster();
    const branchOfficeMaster = this.getSalesOfficeMaster();
    const userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    const officeCode = userInfo.salesOfficeCode;
    const roleId = userInfo.roleId;
    return {
      itemQuotationModalActive: false,
      cpapShippingMethodList,
      cpapSenderMaster,
      departmentMaster: [],
      customerCategory: [],
      searchTargetPostCode: "",
      searchTargetAddress: null,
      cpapStockModalActive: false,
      branchOfficeMaster,
      officeCode,
      depositoryCodeMaster: [],
      webHtApiErr: false,
      renderKey: true,
      quotationItemCode: "",
      quotationItemName: "",
      quotationItemIndex: "",
      quotationItemKind: "",
      invalidPostcode: false,
      invalidMobilePhoneNumber: false,
      invalidNumberMessage,
      postcodePlaceholder,
      phonePlaceholder,
      userInfo,
      roll,
      roleId,
      orderDevice: false,
      orderMask: false,
      orderOption: false,
      orderBundle: false,
      cpapCodeMaster,
      escrowDeviceSelectList,
      escrowMaskSelectList,
      escrowOptionItemSelectList,
      escrowBundleItemSelectList,
      quantitySelectList,
      picoNesalMaskList,
      wispNesalMaskList,
      escrowItemCodeList,
    };
  },
  components: {
    QuotationSelectModal,
    CpapStockModal,
  },
  filters: {
    codeToValueFilter: function (val, list) {
      var target = list.find((item) => item.code == val);
      if (target) {
        return target.name;
      }
      return "";
    },
  },
  mounted: async function () {
    // CPAP選択肢リスト取得
    await this.getCpapChoicesList();
    await this.getDepositoryCodeMaster();
    if (this.webHtApiErr) return;
    // 表示判断
    if (
      this.data.escrowDeviceList.length > 0 &&
      this.data.escrowDeviceList[0].itemCode
    ) {
      this.orderDevice = true;
    }
    if (
      this.data.escrowMaskList.length > 0 &&
      this.data.escrowMaskList[0].itemCode
    ) {
      this.orderMask = true;
    }
    if (
      this.data.escrowOptionItemList.length > 0 &&
      this.data.escrowOptionItemList[0].itemCode
    ) {
      this.orderOption = true;
    }
    if (
      this.data.escrowBundleItemList.length > 0 &&
      this.data.escrowBundleItemList[0].itemCode
    ) {
      this.orderBundle = true;
    }

    // 納品先が支店なら発送元は自動で川越
    if (this.data.delivaryTarget == "branch") {
      this.data.senderType = 0;
    }

    //支店情報取得
    await this.getBrunchAddressList();
  },
  created: function () {
    this.$validator.extend("validationCheck", {
      getMessage: (field) => `入力内容に誤りがあります。再度入力してください。`,
      validate: (value, indexArray) => {
        var ret = false;
        var value = indexArray[0];
        // 正規表現にカンマが含まれるとパラメタ数が変化するのでここで結合する
        var validationRule = "";

        if (value.indexOf("'") != -1) {
          // シングルコーテーションはサーバ側でSQLエラーとなる為、ここではじく
          return false;
        }

        for (var i = 1; i < indexArray.length; i++) {
          validationRule += decodeURI(indexArray[i]);
          if (i != indexArray.length - 1) {
            validationRule += ",";
          }
        }
        validationRule = validationRule.replace(/'/g, "");
        // 入力値チェック
        var regex = RegExp(validationRule);
        if (regex.test(value)) {
          ret = true;
        }
        return ret;
      },
    });
  },
  watch: {
    "data.deliveryTargetBranchOffice"() {
      // 選択された支店に応じて営業所マスタから値を取得し画面に反映する
      const targetBranch = this.brunchList.find(
        (v) => v.branchOfficeCode == this.data.deliveryTargetBranchOffice
      );
      this.data.deliveryPostCode = targetBranch.postCode.replace(/[^0-9]/g, "");
      this.data.deliveryAddress1 = targetBranch.address;
      this.data.receiverName =
        this.userInfo.lastName + " " + this.userInfo.firstName;
      this.data.deliveryPhoneNumber = targetBranch.phoneNumber.replace(
        /[^0-9]/g,
        ""
      );
    },
  },
};
</script>

<style lang="scss" scoped>
#item-contens table tr {
  height: 35px;
}
#item-contens table select {
  height: 30px;
}
#prescriptionTable th {
  width: 280px;
}
#editMark {
  width: 50px;
  vertical-align: middle;
}
.clearBtn {
  margin-left: 5px;
  height: 27px !important;
  width: 27px !important;
}
.change::after {
  position: static;
}
.w-45 {
  width: 45px;
}
.tdBold {
  vertical-align: middle;
  font-weight: bold;
  color: black;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/mock/common/CpapEscrowRequestDetailEdit.vue